import { Component, OnInit, Input, output } from '@angular/core';
import { DichiarazioneDto } from 'app/domain/DichiarazioneDto';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-download-dichiarazioni',
    templateUrl: './download-dichiarazioni.component.html',
    styleUrls: ['./download-dichiarazioni.component.scss'],
    imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem]
})
export class DownloadDichiarazioniComponent implements OnInit {
  @Input()
  dichiarazioni: DichiarazioneDto[];

  readonly downloadDichiarazione = output<string>();

  constructor() { }

  ngOnInit() {
  }

  onDownloadDichiarazione(idDichiarazione: string) {
    this.downloadDichiarazione.emit(idDichiarazione);
  }
}
